import { render, staticRenderFns } from "./Cta.vue?vue&type=template&id=37e2dd48&"
import script from "./Cta.controller.js?vue&type=script&lang=js&"
export * from "./Cta.controller.js?vue&type=script&lang=js&"
import style0 from "./Cta.styles.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports